/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetReservationNotesRequest
 */
export interface SetReservationNotesRequest {
    /**
     * The Gondola-internal numeric booking id (as a string).
     * @type {string}
     * @memberof SetReservationNotesRequest
     */
    bookingId: string;
    /**
     * The full notes text to store (replaces any existing notes); null/empty clears.
     * @type {string}
     * @memberof SetReservationNotesRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the SetReservationNotesRequest interface.
 */
export function instanceOfSetReservationNotesRequest(value: object): value is SetReservationNotesRequest {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function SetReservationNotesRequestFromJSON(json: any): SetReservationNotesRequest {
    return SetReservationNotesRequestFromJSONTyped(json, false);
}

export function SetReservationNotesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetReservationNotesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function SetReservationNotesRequestToJSON(json: any): SetReservationNotesRequest {
    return SetReservationNotesRequestToJSONTyped(json, false);
}

export function SetReservationNotesRequestToJSONTyped(value?: SetReservationNotesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'notes': value['notes'],
    };
}

